import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7V5H9V7H11Z",
			fill: "#09334B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15V9H9V15H11Z",
			fill: "#09334B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 10C0 4.47998 4.47998 0 10 0C15.52 0 20 4.47998 20 10C20 15.52 15.52 20 10 20C4.47998 20 0 15.52 0 10ZM2 10C2 14.41 5.59003 18 10 18C14.41 18 18 14.41 18 10C18 5.59003 14.41 2 10 2C5.59003 2 2 5.59003 2 10Z",
			fill: "#09334B"
		})
	]
});
export default SvgInfoBlack;
